export default __webpack_public_path__ + "static/media/No45.436c317d.jpg";